import MaterialsApiService from "./api/MaterialsApiService";

export const createDiscipline = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post('/disciplines', payload, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao adicionar disciplina', error);

    throw error;
  }
};

export const findDiscipline = async (payload) => {
  try {
    let URL = `/disciplines/${payload.disciplineId}?`
    payload?.include && (URL += `include=${payload.include}&`)

    const response = await MaterialsApiService.get(URL);
    return response.data;
  } catch (error) {
    console.error('Erro ao consultar disciplina', error);

    throw error;
  }
};

export const updateDiscipline = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.put('/disciplines/' + payload.disciplineId, payload, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar disciplina', error);

    throw error;
  }
};

export const deleteDiscipline = async (disciplineId, userToken) => {
  try {
    const response = await MaterialsApiService.delete('/disciplines/' + disciplineId, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao deletar disciplina', error);

    throw error;
  }
};

export const getDisciplines = async (payload, userToken) => {
  try {
    let url = '/disciplines?';

    if (payload?.include) {
      url += `include=${payload.include}&`;
    }

    if (payload.search) {
      url += `search=${payload.search}&`;
    }

    if (payload.tagsIds && payload.tagsIds.length > 0) {
      const tagsIds = payload.tagsIds
        .filter(id => id !== undefined && id !== null)
        .map(id => `tags_ids[]=${id}`)
        .join('&');

      url += `${tagsIds}&`;
    }

    if (payload.type) {
      url += `type=${payload.type}&`;
    }

    if (payload.consumerId) {
      url += `consumer_id=${payload.consumerId}&`;
    }

    if (payload.page) {
      url += `page=${payload.page}&`;
    }

    if (payload.perPage) {
      url += `per_page=${payload.perPage}&`;
    }

    if (payload?.filterStatus !== undefined && payload?.filterStatus !== null) {
      url += `in_use=${payload.filterStatus}&`;
    }

    if (payload?.favorite) {
      url += `favorites=${payload.favorite}&`;
    }

    const response = await MaterialsApiService.get(url.slice(0, -1), {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao consultar disciplinas:', error);
    throw error;
  }
}

export const insertTags = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/disciplines/${payload.disciplineId}/discipline-tag`, { discipline_tag_ids: payload.disciplineTagIds }, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao inserir tag na disciplina', error);

    throw error;
  }
};

export const removeTag = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/disciplines/${payload.disciplineId}/discipline-tag/remove`, { discipline_tag_id: payload.disciplineTagId }, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao remover tag na disciplina', error);

    throw error;
  }
};

export const duplicateDiscipline = async (disciplineId, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/disciplines/${disciplineId}/duplicate`, [], {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.log('Erro ao duplicar disciplina', error);

    throw error;
  }
};

export const disciplineAnalysis = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/disciplines/analysis`, payload, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao analisar disciplina', error);
  }
}

export const updateDisciplineFavoriteState = async (disciplineId) => {
  try {
    const response = await MaterialsApiService.post(`/disciplines/${disciplineId}/favorite`)
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao favoritar disciplina! Tente novamente")
  }
}

export const getDisciplineComments = async (payload) => {
  let URL = `/disciplines/${payload?.disciplineId}/comments?`
  payload?.page && (URL += `page=${payload.page}&`)
  payload?.perPage && (URL += `per_page=${payload.perPage}&`)
  payload?.search && (URL += `search=${payload.search}&`)

  try {
    const response = await MaterialsApiService.get(URL)
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao requisitar Comentários de Disciplina! Tente novamente")
  }
}

export const getDisciplineFeedback = async (disciplineId) => {
  try {
    const response = await MaterialsApiService.get(`/disciplines/${disciplineId}/feedbacks`)
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao requisitar Feedbacks de Disciplina! Tente novamente")
  }
}

export const getDisciplinesFeedback = async (payload) => {
  try {
    let URL = '/dashboard/feedbacks?'
    payload?.page && (URL += `page=${payload.page}&`)
    payload?.perPage && (URL += `per_page=${payload.perPage}&`)
    payload?.search && (URL += `discipline_name=${payload.search}&`)

    const response = await MaterialsApiService.get(URL)
    return response?.data
  } catch {
    throw new Error("Ocorreu um erro ao requisitar Feedback de Disciplinas! Tente novamente")
  }
}

const reditectUserToCSV = (fileURL) => {
  window.open(fileURL, '_blank')
}

export const exportDisciplineFeedbacks = async (disciplineID) => {
  try {
    const response = await MaterialsApiService.get(`/disciplines/${disciplineID}/export/csv`)
    reditectUserToCSV(response?.data?.download_url)
  } catch {
    throw new Error("Ocorreu um erro ao exportar feedbacks de disciplina! Tente novamente")
  }
}

export const restrictDisciplineToConsumers = async (requestPayload) => {
  try {
    const response = await MaterialsApiService.post(`/disciplines/${requestPayload?.disciplineId}/restrict-consumers`, requestPayload)
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao restringir disciplina aos consumidores! Tente novamente")
  }
}

export const removeDisciplineRestrictionToConsumers = async (requestPayload) => {
  try {
    const response = await MaterialsApiService.post(`/disciplines/${requestPayload?.disciplineId}/restrict-consumers/remove`, requestPayload)
    return response.data
  } catch {
    throw new Error("Ocorreu um erro ao remover restrição da disciplina aos consumidores! Tente novamente")
  }
}

export const attachOnCurriculum = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/disciplines/${payload.disciplineId}/curricula/${payload.curriculumId}/attach`, payload, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao adicionar disciplina ao currículo', error);

    throw error;
  }
}

export const detachFromCurriculum = async (payload, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/disciplines/${payload.disciplineId}/curricula/${payload.curriculumId}/detach`, payload, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao remover disciplina do currículo', error);

    throw error;
  }
}

export const syncDisciplineGrades = async (disciplineId, userToken) => {
  try {
    const response = await MaterialsApiService.post(`/disciplines/${disciplineId}/grades/sync`, {}, {
      headers: {
        Authorization: 'Bearer ' + userToken
      }
    });

    return {
      status: response.status,
      message: response?.data?.message || null,
      data: response?.data || null
    };
  } catch (error) {
    console.error('Erro ao sincronizar notas da disciplina', error);
    throw error;
  }
}

export default {
  restrictDisciplineToConsumers,
  removeDisciplineRestrictionToConsumers,
  updateDisciplineFavoriteState,
  exportDisciplineFeedbacks,
  getDisciplinesFeedback,
  getDisciplineFeedback,
  getDisciplineComments,
  createDiscipline,
  findDiscipline,
  updateDiscipline,
  deleteDiscipline,
  getDisciplines,
  insertTags,
  removeTag,
  duplicateDiscipline,
  disciplineAnalysis,
  attachOnCurriculum,
  detachFromCurriculum,
  syncDisciplineGrades
}
